export const DARK = 'dark';
export const LIGHT = 'light';